/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CampaignLinkEventEnum {
    CampaignLinkCheckoutStarted = 'CampaignLinkCheckoutStarted',
    CampaignLinkApplied = 'CampaignLinkApplied',
    CampaignLinkRejected = 'CampaignLinkRejected'
}

export function CampaignLinkEventEnumFromJSON(json: any): CampaignLinkEventEnum {
    return CampaignLinkEventEnumFromJSONTyped(json, false);
}

export function CampaignLinkEventEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignLinkEventEnum {
    return json as CampaignLinkEventEnum;
}

export function CampaignLinkEventEnumToJSON(value?: CampaignLinkEventEnum | null): any {
    return value as any;
}

